import { create } from 'zustand';
import { MappedEventTypes } from '@src/common/types/empTypes';
import { CollapseProps } from 'antd';

export interface NetworkRequestPattern {
  host: string;
  path: string;
}
export type TToolTypes = 'livelens' | 'validation' | 'eventlooker' | 'deployment' | null;

export interface IFlowStore {
  formInstance: any;
  setFormInstance: (formInstance: any) => void;
  // default is section 1
  activeSectionKey: CollapseProps['activeKey'];
  setActiveSectionKey: (activeKey: CollapseProps['activeKey']) => void;
  activeTool: TToolTypes;
  setActiveTool: (activeTool: TToolTypes) => void;
  deploymentStatus: 'inprogress' | 'success' | 'failed' | null;
  setDeploymentStatus: (status: 'inprogress' | 'success' | 'failed' | null) => void;
  initialEvent: MappedEventTypes | null;
  setInitialEvent: (initialEvent: MappedEventTypes | null) => void;
  completeEvent: MappedEventTypes | null;
  setCompleteEvent: (completeEvent: MappedEventTypes | null) => void;
  withoutEvent: MappedEventTypes | null;
  setWithoutEvent: (withoutEvent: MappedEventTypes | null) => void;
  errorEvents: (MappedEventTypes | number | string)[] | [];
  setErrorEvents: (errorEvents: (MappedEventTypes | number | string)[] | []) => void;
  /** Prefill when creating a flow from an external source (e.g. clipboard import). */
  selectedFlow: unknown;
  setSelectedFlow: (flow: unknown) => void;
  resetAll: () => void;

  applyErrorEvent: (
    // string is for raw event
    event: MappedEventTypes | string,
  ) => void;
}
// when a section has its own draft existing, it's status will be editing

export const useFlowStore = create<IFlowStore>((set, get) => ({
  formInstance: null,
  setFormInstance: (formInstance) => set({ formInstance }),
  activeSectionKey: ['1'], // default is section 1
  setActiveSectionKey: (activeKey) => set({ activeSectionKey: activeKey }),
  activeTool: null,
  setActiveTool: (activeTool: TToolTypes) => set({ activeTool }),
  deploymentStatus: null,
  setDeploymentStatus: (status) => set({ deploymentStatus: status }),
  initialEvent: null,
  setInitialEvent: (initialEvent) => {
    set({ initialEvent });
  },
  completeEvent: null,
  setCompleteEvent: (completeEvent) => {
    set({ completeEvent });
  },
  withoutEvent: null,
  setWithoutEvent: (withoutEvent) => {
    set({ withoutEvent });
  },
  errorEvents: [],
  setErrorEvents: (errorEvents) => {
    set({ errorEvents });
  },
  selectedFlow: undefined,
  setSelectedFlow: (flow) => set({ selectedFlow: flow }),
  networkRequestPatterns: [],
  applyErrorEvent: (event) => {
    get().setErrorEvents([...get().errorEvents, event]);
    // @ts-ignore
    const activeSectionKey: any[] = get().activeSectionKey || [];
    if (!activeSectionKey.includes('2')) {
      get().setActiveSectionKey([...activeSectionKey, '2']);
    }
  },
  resetAll: () => {
    get().setActiveTool(null);
    get().setInitialEvent(null);
    get().setCompleteEvent(null);
    get().setWithoutEvent(null);
    get().setDeploymentStatus(null);
    get().setActiveSectionKey(['1']);
    get().setSelectedFlow(undefined);
  },
}));
